import React from "react"
import {IndexRoute, Redirect, Route, Link, Switch, withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {push} from "react-router-redux";
import {register} from "../../../actions/auth-actions";
import {setNotification} from "../../../actions/notifications-actions";
import RegistrationForm from './forms/registration-form';
import * as types from "../../../actions/types";
import YCComponent from "../../yc-component";

class LecturerRegistration extends YCComponent {

    constructor(props) {
        super(props);
        this.state = {
            finished: false
        }
    }

    register = (values) => {
        return new Promise((resolve, reject) => {
            this.props
                .register({ lecturer: values })
                .then((response) => {
                    if (response.type === types.AUTH_REGISTER_SUCCESS) {
                        this.props.setNotification('success','Registrace byla úspěšná. Za několik minut obdržíte e-mail s instrukcemi k potvrzení vašeho účtu.');
                        this.setState({...this.state, finished: true});
                        resolve();
                        console.log('hodnota lecturer', values);
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                        'event': 'lecturer_registered'
                        });
                    } else {
                        if (response.payload.response) {
                            reject(response.payload.response.errors);
                        } else {
                            this.props.setNotification('danger','Vyskytla se neočekávaná chyba.');
                        }
                    }
                })
        });
    };

    render() {
        if (this.state.finished) {
            return (
                <div className='text-center container'>
                    <h1 className='display-2 text-center'>Děkujeme za registraci!</h1>
                    <p>Během několika minut obdržíte potvrzovací email s instrukcemi k aktivaci vašeho účtu.</p>
                    <p><Link to='/lecturers/confirmation'>Vyžádání nového potvrzovacího emailu.</Link></p>
                </div>
            );
        }

        return (
            <div className='container'>
                <h1 className='page-title'>Registrace</h1>
                <div className='card auth-card'>
                    <div className='card-body'>
                        <div className='row'>
                            <div className='col-lg-6'>
                                <p><strong>Vytvořte si ID, se kterým budete moci vytvářet týmy.</strong></p>
                                <p>Dali jste dohromady tým a chcete soutěžit? Nejdříve se musí registrovat někdo dospělý, kdo váš tým do soutěže přihlásí. Ale nebojte, ke svému soutěžnímu účtu se pak dostanete i bez něj.</p>
                            </div>
                            <div className='col-lg-6'>
                                <RegistrationForm onSubmit={this.register}/>
                                <small>
                                    <p>Už máte svůj profil? <Link to='/lecturers/sign-in'>Přihlaste se.</Link></p>
                                    <p>Chcete se přihlásit za konkrétní tím? <Link to='/students/sign-in'>Přihlaste se.</Link></p>
                                    <span><Link to='/lecturers/confirmation'>Vyžádání potvrzovacího emailu.</Link></span>
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


function mapStateToProps(state,ownProps) {
    return {
        location: ownProps.location,
        auth: state.auth
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        setNotification: setNotification,
        push: push,
        register: register
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(LecturerRegistration);
